import { render, staticRenderFns } from "./ClientPrivacyPolicy.vue?vue&type=template&id=083d1cac"
import script from "./ClientPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ClientPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports